<template>
  <div class="vkb_nak vkb_nak_vkb vkb_nak_privat_ubr">
    <div class="wrapper-spacing small-12 medium-12 large-12 columns">
      <div class="ubr-content-container">
        <div class="row">
          <div class="large-7 columns ubr-content-container--left">
            <h3>Private Unfallversicherung ...<br>&nbsp;</h3>

            <div
              v-for="ubr_item in ubr_left_items"
              :key="ubr_item.id"
              :class="[ `ubr-item ubr-item--item${ ubr_item.id }` ]"
            >
              <div class="ubr-item__info highlight" @click="() => openUbrItem(ubr_item.id, ubr_item.tracking_name)">
                <div class="ubr-item__info--icon">
                  <i :class="`fo ${ ubr_item.icon }`" />
                </div>

                <div :class="[ 'ubr-item__info--list', { 'selected': ubr_item.id === ubrItemId } ]">
                  <div v-if="ubr_item.id !== 1" class="ubr-info-puls-icon">
                    <img :src="hasAssetPath ? assetPath(`images/plus.png`) : imgPlus">
                  </div>

                  <h4 class="top-headline h4">
                    <img :src="hasAssetPath ? assetPath('images/arrow.png') : imgArrow">
                    {{ ubr_item.name }}
                  </h4>

                  <ul>
                    <li v-for="(list_item, index) in ubr_item.items" :key="index">
                      {{ list_item.caption }}
                    </li>
                  </ul>
                </div>
              </div>

              <div v-if="ubrItemId === ubr_item.id" class="ubr-item__details">
                <h3 class="top-headline h3">
                  {{ ubr_item.description }}
                </h3>

                <div
                  v-for="(item, index) in ubr_item.items"
                  :key="index"
                  :class="index && 'mb-20'"
                >
                  <h4 v-if="item.caption" class="top-headline h4">
                    {{ item.caption }}
                  </h4>
                  <p v-html="item.text" />
                </div>
              </div>
            </div>
          </div>

          <div class="large-5 columns ubr-content-container--right">
            <img :src="hasAssetPath ? assetPath('images/plus_center.png') : imgPlusCenter" class="ubr-plus-icon">
            <h3>... mit garantierter<br>Beitragsrückzahlung</h3>

            <div
              v-for="ubr_item in ubr_right_items"
              :key="ubr_item.id"
              :class="[ `ubr-item ubr-item--item${ ubr_item.id }` ]"
            >
              <div class="ubr-item__info highlight" @click="() => openUbrItem(ubr_item.id, ubr_item.tracking_name)">
                <div :class="[ 'ubr-item__info--list', { 'selected': ubr_item.id === ubrItemId } ]">
                  <div v-if="ubr_item.id !== 4" class="ubr-info-puls-icon">
                    <img :src="hasAssetPath ? assetPath(`images/plus.png`) : imgPlus">
                  </div>

                  <h4 :class="[ 'top-headline h4', { 'mb-0': ubr_item.id === 4 } ]">
                    <img :src="hasAssetPath ? assetPath('images/arrow.png') : imgArrow">
                    <span v-html="ubr_item.title" />
                  </h4>

                  <ul>
                    <li v-for="(list_item, index) in ubr_item.list_items" :key="index">
                      {{ list_item }}
                    </li>
                  </ul>

                  <div v-if="ubr_item.id === 5" class="ubr-info-image">
                    <img :src="hasAssetPath ? assetPath('images/euro_card.png') : imgEuroCard">
                  </div>
                </div>
              </div>

              <div v-if="ubrItemId === ubr_item.id" class="large-12 columns ubr-item__details">
                <h3 class="top-headline h3">
                  {{ ubr_item.details.title }}
                </h3>

                <div
                  v-for="(detail_item, index) in ubr_item.details.items"
                  :key="index"
                  :class="index && 'mb-20'"
                >
                  <h4 v-if="detail_item.caption" class="top-headline h4">
                    {{ detail_item.caption }}
                  </h4>
                  <p v-html="detail_item.text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AssetHandler from '@/mixins/assetHandler.js';
import TrackingHandler from '@/mixins/trackingHandler.js';

export default {
  name: 'vkb_nak_privat_ubr_vkb',

  mixins: [
    AssetHandler,
    TrackingHandler
  ],

  data() {
    return {
      ubrItemId: 0,
      imgPlus: require('@/assets/images/plus.png'),
      imgArrow: require('@/assets/images/arrow.png'),
      imgPlusCenter:  require('@/assets/images/plus_center.png'),
      imgEuroCard: require('@/assets/images/euro_card.png'),

      ubr_left_items: [
        {
          id: 1,
          name: 'Serviceleistung',
          tracking_name: 'serviceleistung',
          icon: 'fo-serviceleistung fo-detail',
          description: 'Optionale Serviceleistungen',
          items: [
            {
              caption: 'RehaManager',
              text: 'Wir helfen nach einem schweren Unfall bei notwendigen medizinischen, beruflichen, technischen und pflegerischen Reha-Maßnahmen. Von der Auswahl spezifischer Fachärzte, über die Wiedereingliederung in den Beruf und/oder die notwendige Umrüstung Ihres Autos, bis hin zur Klärung des Pflegebedarfs – wir organisieren und bezahlen Hilfeleistungen. Bis 3 Jahre nach einem Unfall (bei voraussichtlicher Invalidität ab 25 Prozent).'
            },
            {
              caption: 'AlltagsManager',
              text: 'Ob Kinderbetreuung, Haushaltshilfe, Gartenpflege, Menüservice, Fahrdienste oder das Unterbringen Ihrer Haustiere – wir kümmern uns um die alltäglichen Dinge, wenn Sie dazu nicht in der Lage sind, bis 6 Monate nach einem Unfall, einer ambulanten Operation oder einem stationären Krankenhausaufenthalt. Damit können Sie sich voll und ganz auf Ihre Genesung konzentrieren.'
            }
          ]
        },
        {
          id: 2,
          name: 'Ergänzungsschutz',
          tracking_name: 'ergaenzungsschutz',
          icon: 'fo-krankenhaus fo-detail',
          description: 'Wichtige optionale Leistungen im Ergänzungsschutz',
          items: [
            {
              caption: 'Sofortleistung',
              text: 'Wir zahlen einmalig bei einem Oberschenkelhalsbruch und bestimmten unfallbedingten Verletzungen.'
            },
            {
              caption: 'Leistung bei Unfalltod',
              text: 'Wir zahlen die vereinbarte Leistung an die Bezugsberechtigten – auch bei Verschollenheit.'
            },
            {
              caption: 'Krankenhaus-Tagegeld',
              text: 'Wir zahlen ein Krankenhaus-Tagegeld bei einem unfallbedingtem stationären Krankenhausaufenthalt oder einer ambulanten OP nach einem Unfall für max. 5 Jahre.'
            }
          ]
        },
        {
          id: 3,
          name: 'Kernschutz',
          tracking_name: 'kernschutz',
          icon: 'fo-unfall1 fo-detail',
          description: 'Ausgezeichnete Leistungen im Kernschutz',
          items: [
            {
              caption: 'Kapitalleistung bei Invalidität',
              text: 'Je schwerer die Folgen eines Unfalls, desto nötiger ist ein hoher finanzieller Ausgleich. Gut zu wissen, dass wir ab jedem messbaren Grad der Invalidität zahlen.'
            },
            {
              caption: 'Unfallrente',
              text: 'Zahlung erfolgt ab 30, 50 oder 90 Prozent Invaliditätsgrad lebenslang oder bis zum 67. Lebensjahr – Sie entscheiden.'
            }
          ]
        }
      ],

      ubr_right_items: [
        {
          id: 4,
          title: 'Überschüsse',
          tracking_name: 'ueberschuesse',
          details: {
            title: 'Überschüsse möglich',
            items: [
              {
                caption: '',
                text: 'Am Ende der Vertragslaufzeit erhalten Sie zusätzlich zur garantierten Beitragsrückzahlung eine mögliche Überschussbeteiligung. Da diese von der zukünftigen Entwicklung an den Kapitalmärkten abhängig ist, kann die Überschussbeteiligung nicht garantiert werden.'
              }
            ]
          }
        },
        {
          id: 5,
          title: 'Garantierte<br>&emsp;&ensp;&nbsp;Rückzahlung',
          tracking_name: 'garantierte_rueckzahlung',
          list_items: [
            'Individuelle Vertragsgestaltung',
            'Sichere Auszahlung, unabhängig davon, ob ein Unfall passiert'
          ],
          details: {
            title: 'Garantierte Rückzahlung',
            items: [
              {
                caption: 'Individuelle Vertragsgestaltung',
                text: 'Sie haben die Wahl, wie Sie bezahlen möchten, denn unsere UBR gibt es auch als Einmalbeitragsversicherung. Außerdem wählen Sie Ihre indiviuelle Auszahlungshöhe, die Anzahl der beitragsfreien Jahre und die Dauer Ihrer Beitragszahlung.'
              },
              {
                caption: 'Sichere Auszahlung',
                text: 'Am Ende der Vertragslaufzeit erhalten Sie garantiert Beiträge zurück. Ganz unabhängig davon, ob Sie als Versicherter zuvor Leistungen in Anspruch genommen haben oder nicht.'
              }
            ]
          }
        }
      ]
    };
  },

  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config() {
      return this.appConfigs[this.$options.configIndex] || {};
    },
  },

  methods: {
    openUbrItem(id, actionType) {
      if (this.ubrItemId === id) {
        this.ubrItemId = null;
        return;
      }

      this.ubrItemId = id;
      this.triggerActionEvent(actionType, 'infografik');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/privat_ubr/vkb.vue